import { Controller } from "@hotwired/stimulus";

// Hover/focus readout for the Affiliate Earnings timeline. Each column's hit
// area carries data-tip (a JSON list of lines); this positions one tooltip
// over it. The same numbers are in the table under the chart, so the tooltip
// adds convenience, never information you can't reach otherwise.
export default class extends Controller {
  static targets = ["tip"];

  show(event) {
    const hit = event.currentTarget;
    let lines;
    try {
      lines = JSON.parse(hit.dataset.tip || "[]");
    } catch {
      return;
    }
    const tip = this.tipTarget;
    tip.replaceChildren(
      ...lines.map((line, i) => {
        const el = document.createElement(i === 1 ? "strong" : "div");
        el.textContent = line;
        return el;
      })
    );
    tip.hidden = false;

    const box = this.element.getBoundingClientRect();
    const rect = hit.getBoundingClientRect();
    const center = rect.left + rect.width / 2 - box.left;
    const left = Math.min(
      Math.max(center - tip.offsetWidth / 2, 0),
      box.width - tip.offsetWidth
    );
    tip.style.left = `${left}px`;
  }

  hide() {
    this.tipTarget.hidden = true;
  }
}
